import PropTypes from "prop-types";
import React from "react";
import { Bar } from "react-chartjs-2";

export default function BarDiagram({ data, ...props }) {

  const chartData = {
    labels: props.labels,
    datasets: props.datasets ? props.datasets : [
      {
        label: props.diagramLabel,
        data: data,
        backgroundColor: props.backgroundColor,
        hoverBackgroundColor: props.hoverBackgroundColor,
        borderWidth: props.borderWidth,
      }
    ]
  };

  return (
    <Bar
      data={chartData}
      options={props.options}
    />
  );
}

BarDiagram.propTypes = {
  label: PropTypes.string,
  labels: PropTypes.array,
  data: PropTypes.array,
  backgroundColor: PropTypes.array,
  hoverBackgroundColor: PropTypes.array,
  borderWidth: PropTypes.number,
  options: PropTypes.object
};

BarDiagram.defaultProps = {
  label: "",
  labels: [],
  data: [],
  backgroundColor: [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#2196f3",
    "#ff5722",
    "#009688",
    "#3f51b5",
    "#4caf50",
    "#ff9800",
    "#ffc107",
    "#00bcd4",
    "#673ab7",
    "#8bc34a",
    "#cddc39",
    "#607d8b",
    "#795548",
    "#e91e63",
    "#4dd0e1",
    "#b39ddb",
    "#81c784",
    "#ffe082",
    "#80deea",
    "#ce93d8",
    "#aed581",
    "#ffcc80",
    "#4dd0e1",
    "#9fa8da",
  ],
  hoverBackgroundColor: [
    "#d32f2f",
    "#c2185b",
    "#7b1fa2",
    "#1976d2",
    "#e64a19",
    "#00796b",
    "#303f9f",
    "#388e3c",
    "#f57c00",
    "#fbc02d",
    "#0097a7",
    "#512da8",
    "#689f38",
    "#afb42b",
    "#455a64",
    "#5d4037",
    "#ad1457",
    "#00acc1",
    "#9c27b0",
    "#7cb342",
    "#ffb74d",
    "#26c6da",
    "#ba68c8",
    "#9ccc65",
    "#ffb74d",
    "#26c6da",
    "#7986cb",
  ],
  borderWidth: 0,
  options: {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          suggestedMin: 0,
        }
      }]
    }
  }
};
